import { useValidation } from '@/components';

export const useValidationSchema = () => {
  const createValidationSchema = useValidation();

  return createValidationSchema(({ isStringMaxLength }) => ({
    clientVersionMin: isStringMaxLength(50),
  }));
};
